import { render } from "./baseloader.vue?vue&type=template&id=185ff4c4"
import script from "./baseloader.vue?vue&type=script&lang=js"
export * from "./baseloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__